import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 9 6",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M4.33203 0L8.66216 6H0.00190401L4.33203 0Z" })
});
export default SvgArrowUp;
